const orderActionTypes = {
  CREATE_NEW_ORDER_START: 'CREATE_NEW_ORDER_START',
  CREATE_NEW_ORDER_SUCCESS: 'CREATE_NEW_ORDER_SUCCESS',
  CREATE_NEW_ORDER_FAIL: 'CREATE_NEW_ORDER_FAIL',

  MAKE_BID_START: 'MAKE_BID_START',
  MAKE_BID_SUCCESS: 'MAKE_BID_SUCCESS',
  MAKE_BID_FAIL: 'MAKE_BID_FAIL',

  GET_ORDERS_INFO_START: 'GET_ORDERS_INFO_START',
  GET_ORDERS_INFO_SUCCESS: 'GET_ORDERS_INFO_SUCCESS',
  GET_ORDERS_INFO_FAIL: 'GET_ORDERS_INFO_FAIL',

  GET_ORDERS_START: 'GET_ORDERS_START',
  GET_ORDERS_SUCCESS: 'GET_ORDERS_SUCCESS',
  GET_ORDERS_FAIL: 'GET_ORDERS_FAIL',

  GET_ONE_ORDER_START: 'GET_ONE_ORDER_START',
  GET_ONE_ORDER_SUCCESS: 'GET_ONE_ORDER_SUCCESS',
  GET_ONE_ORDER_FAIL: 'GET_ONE_ORDER_FAIL',

  CONFIRM_ORDER_START: 'CONFIRM_ORDER_START',
  CONFIRM_ORDER_SUCCESS: 'CONFIRM_ORDER_SUCCESS',
  CONFIRM_ORDER_FAIL: 'CONFIRM_ORDER_FAIL',

  CANCEL_ORDER_START: 'CANCEL_ORDER_START',
  CANCEL_ORDER_SUCCESS: 'CANCEL_ORDER_SUCCESS',
  CANCEL_ORDER_FAIL: 'CANCEL_ORDER_FAIL',

  COMPLETE_ORDER_START: 'COMPLETE_ORDER_START',
  COMPLETE_ORDER_SUCCESS: 'COMPLETE_ORDER_SUCCESS',
  COMPLETE_ORDER_FAIL: 'COMPLETE_ORDER_FAIL',

  SEND_COMPLETED_CODE_START: 'SEND_COMPLETED_CODE_START',
  SEND_COMPLETED_CODE_SUCCESS: 'SEND_COMPLETED_CODE_SUCCESS',
  SEND_COMPLETED_CODE_FAIL: 'SEND_COMPLETED_CODE_FAIL',

  SEND_REVIEW_START: 'SEND_REVIEW_START',
  SEND_REVIEW_SUCCESS: 'SEND_REVIEW_SUCCESS',
  SEND_REVIEW_FAIL: 'SEND_REVIEW_FAIL',

  ADD_ORDER_CHAT_MESSAGE: 'ADD_ORDER_CHAT_MESSAGE',
  SET_ORDER_STATUS: 'SET_ORDER_STATUS',
  SET_REVIEW_STATUS: 'SET_REVIEW_STATUS',

  ADD_ORDER_CHAT_PAGE: 'ADD_ORDER_CHAT_PAGE',

  CHANGE_ORDER_STATUS: 'CHANGE_ORDER_STATUS',

  READ_ORDER_MESSAGE_SUCCESS: 'READ_ORDER_MESSAGE_SUCCESS',
};

export default orderActionTypes;
